import { css } from "@compiled/react";
import { useIntl } from "react-intl";

import { Cross } from "@/libraries/wpl/foundations/src/icons/basic/cross";

const searchIconStyle = css({
    "marginBlockStart": "4px",
    "marginInlineEnd": "8px",
    "background": "transparent",
    "border": 0,
    "cursor": "pointer",
    "padding": 0,
    "color": "#64686f",
    "&:hover": {
        svg: {
            backgroundColor: "#dfe1e5"
        }
    },
    "svg": {
        color: "#101214",
        borderRadius: "50%",
        height: "auto",
        padding: "5px",
        width: "30px"
    }
});

export const SearchCloseButton = (props: {
    readonly onClick: React.MouseEventHandler<HTMLButtonElement>;
}) => {
    const intl = useIntl();
    const translated = {
        searchCloseLabel: intl.formatMessage({
            id: "CustomerLandingPage.search.close.label",
            defaultMessage: "Search close"
        })
    };

    return (
        <button
            type="button"
            css={searchIconStyle}
            onClick={props.onClick}
            id="customer-story-search-icon"
            aria-label={translated.searchCloseLabel}
            data-event="clicked"
            data-event-component="button"
            data-event-container="customerStorySearchCloseButton"
            data-product-key="customer"
        >
            <Cross size={"24"} />
        </button>
    );
};
